import { render, staticRenderFns } from "./project_manage.vue?vue&type=template&id=223091da&scoped=true&"
import script from "./project_manage.vue?vue&type=script&lang=js&"
export * from "./project_manage.vue?vue&type=script&lang=js&"
import style0 from "./project_manage.vue?vue&type=style&index=0&id=223091da&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223091da",
  null
  
)

export default component.exports